import {useEffect} from 'react'
import {useNavigate, useParams} from 'react-router'
import {useIntl} from 'react-intl'
import {useMutation, useQuery} from 'react-query'
import {toast} from 'react-toastify'
import {getDepartmentById} from '../../../modules/services/department.service'
import ListText from '../../../components/ui/ListText'
import {PageTitle} from '../../../../_metronic/layout/core'
import {getBreadCrumbs} from './breadcrumbs'
import {convertToRupiah} from '../../../../_metronic/helpers/currency'

const DepartmentDetailPage = () => {
  const {id} = useParams<{id: string}>()
  const navigate = useNavigate()

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  const {data, isLoading} = useQuery(
    ['getDetailCampaign', id],
    async () => await getDepartmentById(id)
  )

  return (
    <>
      {!isLoading && (
        <div className='card mb-10'>
          <div className='card-body d-flex justify-content-between align-items-center py-8'>
            <div className='ms-6'>
              <p className='fw-bold fs-6 p-0 m-0'>Department Detail</p>
            </div>
          </div>
          <div className='separator mb-4'></div>
          <div className='card-body p-9'>
            <div className='row mb-6'>
              <div className='col-md-6'>
                <ListText head={'Department'} content={data?.attributes.name} />
                <ListText
                  head={'Annual Budget'}
                  content={convertToRupiah(data?.attributes.annual_budget)}
                />
                <ListText head={'KPI Redemption'} content={data?.attributes.kpi_redemption} />
                <ListText
                  head={'Conversion Incentive'}
                  content={`${convertToRupiah(data?.attributes.spending)}/${
                    data?.attributes.point_conversation
                  }`}
                />
                <ListText head={'Description'} content={data?.attributes.description} />
              </div>
              {/* {
                !loading ? <><button disabled={data?.attributes?.status === "finished" ? true : false}  className='btn btn-success' onClick={() => mutateAsync({"id" :id,"status":true})}>
                  Active
                </button> <button disabled={data?.attributes?.status === "finished" ? true : false} className='btn btn-danger' onClick={() => mutateAsync({"id" :id,"status":false})}>
                  Non Active
                </button> </>: <button
                 className='btn btn-success'
                 data-kt-indicator="on"
                 type="button"
               >
                 <span className="indicator-progress">Please wait... 
                 <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
              </button> 
              } */}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const DepartmentWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={getBreadCrumbs('configuration/department')}>
        {intl.formatMessage({id: 'MENU.CONFIGURATION.DEPARTMENT'})}
      </PageTitle>
      <DepartmentDetailPage />
    </>
  )
}

export default DepartmentWrapper
